import { PartialType, PickType } from '@nestjs/swagger';
import { SubdivisionBuilderSupervisorDto } from './subdivision-builder-supervisor.dto';
import { SubdivisionBuilderSupervisorCreatableInterface } from '../interfaces/subdivision-builder-supervisor-creatable.interface';

export class SubdivisionBuilderSupervisorCreateDto
  extends PartialType(
    PickType(SubdivisionBuilderSupervisorDto, ['userId', 'subdivisionId']),
  )
  implements SubdivisionBuilderSupervisorCreatableInterface {}
